import React from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames/bind';
import { Panel } from 'components/ui/index';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import IpListFormWrapped from './IpListForm';
import styles from '../index.less';

const cx = classNames.bind(styles);
const { PhantomId } = Enums;

const AddAndEditIpList = ({
  intl,
  currentId,
}) => {
  const { formatMessage } = intl;
  const title = currentId === PhantomId ? formatMessage({ id: 'page.IpWhiteLists.addIpWhiteLists' }) : formatMessage({ id: 'page.IpWhiteLists.editIpWhiteLists' });
  return (
    <Panel
      panelTitle={title}
      contentClasses="pl-lg pr-lg"
    >
      <IpListFormWrapped currentId={currentId} />
    </Panel>
  );
};


AddAndEditIpList.defaultProps = {};
AddAndEditIpList.propTypes = {
  currentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default injectIntl(AddAndEditIpList);



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/component/AddAndEditIpList.jsx